module.exports = __webpack_public_path__ + "static/media/compedia-logo.ed3555c0.png";